import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const portfolioImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/13uCe54C3Y55jMYLXamCJ6/IMG_4963.jpg',
  en: 'Statue of Liberty — Realism',
  es: 'Estatua de la Libertad — Realismo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2yayeq8eS9g3G7GEvzLVuS/IMG_6570_(1).jpg',
  en: 'Lion & Spartan — Black & Grey',
  es: 'León y Espartano — Negro y Gris'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qumJqoKWa21NpDsujb6YpZ/IMG_2631.jpg',
  en: 'Gothic Architecture — Full Sleeve',
  es: 'Arquitectura Gótica — Manga Completa'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mdjhNkvJxWgSanCeDfrSnG/PhotoRoom-20230520_184213-01.jpg',
  en: 'Havana Cuba — Full Sleeve',
  es: 'La Habana Cuba — Manga Completa'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mMji7JAUwNc5MuoKT5w48D/IMG_3329.jpg',
  en: 'Portrait — Fine Art Realism',
  es: 'Retrato — Realismo Fine Art'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vbZ9jwvHfXxYWsBoDTNWAH/IMG_1796.jpg',
  en: 'Owl — Hand Tattoo',
  es: 'Búho — Tatuaje de Mano'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9AAjUgnxc1Ji874Y7xvjiY/IMG_1565.jpg',
  en: 'Woman & Eagle — Realism',
  es: 'Mujer y Águila — Realismo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oCXsoJtCV6dkhXh3eq1may/IMG_1567.jpg',
  en: 'Zeus — Black & Grey',
  es: 'Zeus — Negro y Gris'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pDYdXcaD7eWZqoMxMrXoKA/IMG_8284.jpg',
  en: 'Ravens & Crystals — Neo Traditional',
  es: 'Cuervos y Cristales — Neo Tradicional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iUfTjzz3Brspepm26BZo8p/IMG_3919.jpg',
  en: 'Portrait — Photorealism',
  es: 'Retrato — Fotorrealismo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jq5fDCNrnvNBuf5RD8T8n8/IMG_8086.jpg',
  en: 'Memento Mori — Chest Piece',
  es: 'Memento Mori — Pecho Completo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aRpedt2PY8o9LqtS1iEN9g/IMG_3908.jpg',
  en: 'Elder & Shepherd — Leg Sleeve',
  es: 'Anciano y Pastor — Manga de Pierna'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pFRcNyEc7cA5g96dMX6RKS/IMG_6464.jpg',
  en: 'Egyptian Gods — Chest Piece',
  es: 'Dioses Egipcios — Pecho Completo'
}];
export function PortfolioCarousel() {
  const {
    language
  } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [itemsPerView, setItemsPerView] = useState(3);
  const content = {
    en: {
      label: 'PORTFOLIO',
      headline: 'The Work Speaks For Itself',
      btn: 'See More on Instagram'
    },
    es: {
      label: 'PORTAFOLIO',
      headline: 'El Trabajo Habla Por Sí Solo',
      btn: 'Ver Más en Instagram'
    }
  };
  const t = content[language];
  const totalItems = portfolioImages.length;
  useEffect(() => {
    const handleResize = () => {
      setItemsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const maxIndex = Math.max(0, totalItems - itemsPerView);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1);
  }, [maxIndex]);
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? maxIndex : prev - 1);
  };
  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(nextSlide, 3000);
      return () => clearInterval(timer);
    }
  }, [isHovered, nextSlide]);
  return <section className="py-24 md:py-32 px-6 border-b border-brand-gold/30 overflow-hidden" data-id="element-120">
      <div className="max-w-7xl mx-auto" data-id="element-121">
        <motion.div className="mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-122">
          <span className="text-brand-gold font-sans text-sm tracking-[0.3em] uppercase block mb-4" data-id="element-123">
            {t.label}
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-gold" data-id="element-124">
            {t.headline}
          </h2>
        </motion.div>

        <div className="relative mb-12" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-125">
          {/* Carousel Track */}
          <div className="overflow-hidden px-2 py-4" data-id="element-126">
            <motion.div className="flex gap-6" animate={{
            x: `calc(-${currentIndex * (100 / itemsPerView)}% - ${currentIndex * (24 / itemsPerView)}px)`
          }} transition={{
            type: 'tween',
            ease: 'easeInOut',
            duration: 0.5
          }} data-id="element-127">
              {portfolioImages.map((img, idx) => <div key={idx} className="relative flex-none w-full md:w-[calc(33.333%-16px)] aspect-[4/5] bg-brand-charcoal border border-brand-gold/30 group overflow-hidden" data-id="element-128">
                  <img src={img.src} alt={img[language]} className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-129" />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-brand-black/80 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center" data-id="element-130">
                    <span className="text-brand-gold font-serif text-xl tracking-widest uppercase text-center px-4" data-id="element-131">
                      {img[language]}
                    </span>
                  </div>
                </div>)}
            </motion.div>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-center gap-6 mt-8" data-id="element-132">
            <button onClick={prevSlide} className="p-2 border border-brand-gold text-brand-gold rounded-full hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-133">
              <ChevronLeft className="w-6 h-6" data-id="element-134" />
            </button>

            <div className="flex gap-2" data-id="element-135">
              {Array.from({
              length: maxIndex + 1
            }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${currentIndex === idx ? 'bg-brand-gold w-6' : 'bg-brand-gold/30'}`} data-id="element-136" />)}
            </div>

            <button onClick={nextSlide} className="p-2 border border-brand-gold text-brand-gold rounded-full hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-137">
              <ChevronRight className="w-6 h-6" data-id="element-138" />
            </button>
          </div>
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-139">
          <a href="https://www.instagram.com/krlygoldtattoo?igsh=bHI3MW51NWdnZzk1&utm_source=qr" target="_blank" rel="noopener noreferrer" className="inline-block py-4 px-10 bg-brand-gold text-brand-black font-serif text-lg tracking-widest uppercase transition-all duration-300 hover:bg-brand-gold-light hover:shadow-[0_0_20px_rgba(201,168,76,0.4)]" data-id="element-140">
            {t.btn}
          </a>
        </motion.div>
      </div>
    </section>;
}